/* eslint-disable camelcase */
import * as React from 'react';
import {SetStateAction, useCallback, useEffect, useState} from 'react';
import {Panel, Tabs} from '@baidu/hcui';
import {getTopicItemlist, TopicModule} from '@/services/pages/channel/channel.client';
import {
    SELF_TOPIC_CONTAINER,
    SELF_TOPIC_CONTAINER_TYPE_H,
    SELF_TOPIC_CONTAINER_TYPE_MIX,
    SELF_TOPIC_CONTAINER_TYPE_V,
    SELF_TOPIC_CONTENT_NAME,
    SELF_TOPIC_CONTENT_TYPE_FLOW_BIG,
    SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL,
    SELF_TOPIC_CONTENT_TYPE_HORIZONTAL,
    SELF_TOPIC_EXPERT,
    SELF_TOPIC_IMAGE_NAME,
    SELF_TOPIC_IMAGE_TYPE_BANNER,
    SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN,
    SELF_TOPIC_IMAGE_TYPE_GOLD_ICON,
    SELF_TOPIC_IMAGE_TYPE_HORIZONTAL,
    SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN,
    SELF_TOPIC_IMAGE_TYPE_SWIPER,
    SELF_TOPIC_TOFU_CUBE_NAME,
    SELF_TOPIC_IMAGE_TYPE_SEAMLESS_SPLICING,
    // 图片模块 - value:19 图片大尺寸样式
    SELF_TOPIC_BIG_WIDTH_TYPE_HORIZONTAL,
} from '@/dicts/modelConsts';
import SelfTopicContentFlowSmall from '@/components/flowSmall';
import SelfTopicContentFlowBig from '@/components/flowBig';
import SelfTopicImgDoubleColumn from '@/components/doubleColumn';
import SelfTopicTofuText from '@/components/tofuText';
import SelfTopicImageHorizontal from '@/components/imgHorizontal';
import DiseaseBannerSwipe from '@/pages/specialDisease/swiper';
import DiseaseGoldIcons from '@/pages/specialDisease/goldIcons';
import SelfTopicImgSpecialDoubleColumn from '@/components/specialDoubleColumn';
import {useSearchParams} from '@/hooks/router';
import SelfTopicContentHorizontal from '@/pages/specialDisease/hotContent';
import VideoSwpier from '@/pages/specialDisease/videoSwiper';
import {VALUE_TYPE} from '@/dicts/consts';
import SelfTopicExpert from '../selfTopicExpert';
import SelfTopicContainerAggregation from '../SelfTopicContainerAggregation';
import SelfTopicContainerVertical from '../containerVertical';
import SeamlessPuzzle from '../seamlessPuzzle';
import styles from './index.less';

interface Props {
    page: string;
    sfRef?: string;
    channelBusinessLine?: string;
    infos: TopicModule;
}

interface ItemQuery {
    id?: string;
    moduleId?: number;
    pageSize: number;
    pageNo: number;
    sf_ch?: string;
    preview?: boolean;
    tabName?: string;
}

const SelfTopicContainerHorizontal = ({infos, page, sfRef, channelBusinessLine}: Props) => {

    const [tabs, setTabs] = useState<string[]>([]);
    const [module, setSelectModule] = useState<TopicModule>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [pageNo, setPageNo] = useState<number>(1);
    const [tabIndex, setTabIndex] = useState<number>(0);

    const [itemQuery, setItemQuery] = useState<ItemQuery>({pageSize: 20, pageNo: 1});

    const param = useSearchParams();

    const getCusStyle = (moduleItem: TopicModule) => {
        const styleObj = {
            backgroundColor: moduleItem.moduleBgc ? moduleItem.moduleBgc : 'white',
            borderRadius: moduleItem.moduleFillet === 1 ? '0px' : '12px',
            marginRight: moduleItem.moduleSpace === 1 ? '0' : '10px',
            marginLeft: moduleItem.moduleSpace === 1 ? '0' : '10px',
            marginTop: moduleItem.moduleSpaceBack === 1 ? '0' : '8px',
        };
        return styleObj ?? {};
    };

    useEffect(
        () => {
            setItemQuery({
                id: param.id,
                sf_ch: param.sf_ch,
                // eslint-disable-next-line max-len
                moduleId: (infos.subModuleList && infos.subModuleList.length > 0) ? infos.subModuleList[0].moduleId : 0,
                preview: param.preview,
                pageSize: 20,
                pageNo: pageNo,
                tabName: param.tabName || '',
            });
        },
        [pageNo]
    );


    const handleTabsChange = useCallback(
        index => {
            setTabIndex(index);
            const query = {
                sf_ch: itemQuery?.sf_ch,
                id: param.id,
                pageNo: 1,
                pageSize: itemQuery.pageSize,
                moduleId: (infos.subModuleList && infos.subModuleList.length > (index || 0))
                    ? infos.subModuleList[index || 0].moduleId
                    : 0,
                tabName: param.tabName || '',
            };
            setItemQuery(query);
            setSelectModule(infos.subModuleList[index]);
        },
        [infos.subModuleList, itemQuery.pageSize, itemQuery?.sf_ch, param.id]
    );

    // eslint-disable-next-line complexity
    const fetchItemList = async (
        id?: string,
        moduleId?: number,
        pageSize?: number,
        pageNo?: number,
        sf_ch?: string,
        preview?: boolean
    ) => {
        if (!id || !moduleId) {
            return;
        }
        try {
            const data = await getTopicItemlist({
                id: id,
                moduleId: moduleId,
                pageSize: pageSize || 20,
                pageNo: pageNo || 1,
                sf_ch: sf_ch,
                preview: preview,
            });

            const list = [];
            module?.itemList && list.push(...module.itemList);
            list.push(...data.list);

            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const appendModule = {
                moduleId: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].moduleId
                    : module?.moduleId,
                channelId: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].channelId
                    : module?.channelId,
                moduleName: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].moduleName
                    : module?.moduleName,
                isShowTitle: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].isShowTitle
                    : module?.isShowTitle,
                moduleMaxRows: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].moduleMaxRows
                    : module?.moduleMaxRows,
                moduleEnName: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].moduleEnName
                    : module?.moduleEnName,
                moduleSubTitle: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].moduleSubTitle
                    : module?.moduleSubTitle,
                moduleMaxColumns: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].moduleMaxColumns
                    : module?.moduleMaxColumns,
                moduleType: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].moduleType
                    : module?.moduleType,
                moduleStyle: (infos.subModuleList && infos.subModuleList.length > tabIndex)
                    ? infos.subModuleList[tabIndex].moduleStyle
                    : module?.moduleStyle,
                count: data.count,
                moreUrl: module?.moreUrl,
                itemList: pageNo === 1 ? data.list : list,
            };

            // @ts-ignore
            // setSelectModule(appendModule);

        } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
        }
    };

    useEffect(
        () => {
            fetchItemList(itemQuery.id,
                itemQuery.moduleId,
                itemQuery.pageSize,
                itemQuery.pageNo,
                itemQuery?.sf_ch,
                itemQuery.preview);
        },
        [itemQuery]
    );

    useEffect(
        () => {
            const list: SetStateAction<string[]> = [];
            infos?.subModuleList?.map(
                // eslint-disable-next-line array-callback-return
                module => {
                    list.push(module.moduleName ? module.moduleName : '');
                }
            );
            setTabs(list);
            // eslint-disable-next-line no-unused-expressions
            (infos.subModuleList && infos.subModuleList.length > 0)
                ? setSelectModule(infos.subModuleList[0])
                : null;
        },
        [infos?.subModuleList]
    );

    useEffect(
        () => {
            const currentTab = tabs.findIndex(tab => tab === itemQuery.tabName);
            if (currentTab !== -1 && currentTab !== tabIndex) {
                handleTabsChange(currentTab);
            }
        },
        [itemQuery.tabName, tabs]
    );

    // eslint-disable-next-line complexity
    const renderContent = useCallback(
        // eslint-disable-next-line complexity
        () => {
            switch (module?.moduleEnName) {
                case SELF_TOPIC_IMAGE_NAME:
                    switch (module.moduleStyle) {
                        case SELF_TOPIC_IMAGE_TYPE_BANNER:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            className={styles.diseaseBannerSwipe}
                                            style={getCusStyle(module)}
                                        >
                                            <DiseaseBannerSwipe
                                                page={page}
                                                sfRef={sfRef}
                                                bannersModel={module}
                                                channelBusinessLine={channelBusinessLine}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_IMAGE_TYPE_HORIZONTAL:
                        case SELF_TOPIC_BIG_WIDTH_TYPE_HORIZONTAL:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <SelfTopicImageHorizontal
                                                page={page}
                                                sfRef={sfRef}
                                                infos={module}
                                                channelBusinessLine={channelBusinessLine}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_IMAGE_TYPE_GOLD_ICON:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <DiseaseGoldIcons
                                                page={page}
                                                sfRef={sfRef}
                                                channelBusinessLine={channelBusinessLine}
                                                goldIcons={{
                                                    channelId: module.channelId,
                                                    golds: module.itemList,
                                                    moduleMaxColumns: module.moduleMaxColumns,
                                                    moduleName: module.moduleName,
                                                }}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_IMAGE_TYPE_DOUBLE_COLUMN:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <SelfTopicImgDoubleColumn
                                                page={page}
                                                sfRef={sfRef}
                                                channelBusinessLine={channelBusinessLine}
                                                infos={module}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_IMAGE_TYPE_SPECIAL_DOUBLE_COLUMN:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <SelfTopicImgSpecialDoubleColumn
                                                page={page}
                                                sfRef={sfRef}
                                                infos={module}
                                                channelBusinessLine={channelBusinessLine}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_IMAGE_TYPE_SWIPER:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            key={module.moduleId}
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <VideoSwpier
                                                page={page}
                                                sfRef={sfRef}
                                                channelBusinessLine={channelBusinessLine}
                                                bannersModel={module}
                                                ubcValue="jump_shipinlunbo"
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_IMAGE_TYPE_SEAMLESS_SPLICING:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            className={styles.cardBg}
                                            style={getCusStyle(module)}
                                        >
                                            <SeamlessPuzzle
                                                page={page}
                                                sfRef={sfRef}
                                                infos={module}
                                                channelBusinessLine={channelBusinessLine}
                                                ubcValue="jump_wufengpinjie"
                                            />
                                        </div>
                                    )
                                    : null
                            );
                    }
                    break;
                case SELF_TOPIC_TOFU_CUBE_NAME:
                    return (
                        module?.itemList?.length
                            ? (
                                <div
                                    style={getCusStyle(module)}
                                    className={styles.cardBg}
                                >
                                    <SelfTopicTofuText
                                        page={page}
                                        sfRef={sfRef}
                                        channelBusinessLine={channelBusinessLine}
                                        infos={module}
                                    />
                                </div>
                            )
                            : null
                    );
                case SELF_TOPIC_CONTENT_NAME:
                    switch (module.moduleStyle) {
                        case SELF_TOPIC_CONTENT_TYPE_HORIZONTAL:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <SelfTopicContentHorizontal
                                                sfRef={sfRef}
                                                page={page}
                                                channelBusinessLine={channelBusinessLine}
                                                infos={module}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_CONTENT_TYPE_FLOW_SMALL:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <SelfTopicContentFlowSmall
                                                page={page}
                                                sfRef={sfRef}
                                                infos={module}
                                                innerModel
                                                channelBusinessLine={channelBusinessLine}
                                                // eslint-disable-next-line react/jsx-no-bind
                                                onMoreClick={() => {
                                                    const query = {
                                                        sf_ch: itemQuery?.sf_ch,
                                                        id: param.id,
                                                        pageNo: pageNo + 1,
                                                        pageSize: itemQuery.pageSize,
                                                        moduleId: itemQuery.moduleId,
                                                        tabName: param.tabName || '',
                                                    };
                                                    setItemQuery(query);
                                                }}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_CONTENT_TYPE_FLOW_BIG:
                            return (
                                module?.itemList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <SelfTopicContentFlowBig
                                                page={page}
                                                sfRef={sfRef}
                                                channelBusinessLine={channelBusinessLine}
                                                infos={module}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                    }
                    break;
                case SELF_TOPIC_EXPERT:
                    return (
                        module?.itemList?.length
                            ? (
                                <div
                                    style={getCusStyle(module)}
                                    className={styles.cardBg}
                                >
                                    <SelfTopicExpert
                                        page={page}
                                        channelBusinessLine={channelBusinessLine}
                                        sfRef={sfRef}
                                        infos={module}
                                    />
                                </div>
                            )
                            : null
                    );
                case SELF_TOPIC_CONTAINER:
                    switch (module.moduleStyle) {
                        case SELF_TOPIC_CONTAINER_TYPE_H:
                            return (
                                module?.subModuleList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <SelfTopicContainerHorizontal
                                                page={page}
                                                channelBusinessLine={channelBusinessLine}
                                                sfRef={sfRef}
                                                infos={module}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_CONTAINER_TYPE_V:
                            return (
                                module?.subModuleList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <SelfTopicContainerVertical
                                                page={page}
                                                channelBusinessLine={channelBusinessLine}
                                                sfRef={sfRef}
                                                infos={module}
                                            />
                                        </div>
                                    )
                                    : null
                            );
                        case SELF_TOPIC_CONTAINER_TYPE_MIX:
                            return (
                                module?.subModuleList?.length
                                    ? (
                                        <div
                                            style={getCusStyle(module)}
                                            className={styles.cardBg}
                                        >
                                            <SelfTopicContainerAggregation
                                                page={page}
                                                channelBusinessLine={channelBusinessLine}
                                                sfRef={sfRef}
                                                infos={module}
                                            />
                                        </div>
                                    )
                                    : null
                            );

                    }
            }
        },
        [
            channelBusinessLine,
            itemQuery.moduleId,
            itemQuery.pageSize,
            itemQuery?.sf_ch,
            module,
            page,
            pageNo,
            param.id,
            param.tabName,
            sfRef,
        ]
    );


    return (
        <div
            data-show={JSON.stringify({
                'page': page,
                'value': 'jump_rongqi_henghua',
                'pageSourceId': infos.channelId,
                'pageType': channelBusinessLine,
                'valueId': infos.moduleId,
                'valueTitle': infos.moduleName,
                'valueType': VALUE_TYPE.MODULE,
            })}
        >
            {
                tabs?.length ? (
                    <div className={styles.tabContentBg}>
                        <Tabs
                            value={tabIndex || 0}
                            lineWidth={48}
                            lineBackgroundColor={'#1f1f1f'}
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange={
                                index => {
                                    handleTabsChange(index);
                                }
                            }
                        >
                            {
                                tabs.map(
                                    tabInfo => (
                                        <Panel title={tabInfo} key={tabInfo} />
                                    )
                                )
                            }
                        </Tabs>
                    </div>
                )
                    : null
            }

            {
                renderContent()
            }

        </div>
    );
};

export default SelfTopicContainerHorizontal;
